import { createContext, createElement, useContext, type ReactNode } from "react";
import type { LedgerRef } from "@/lib/ledger";
export const LedgerContext = createContext<LedgerRef | null>(null);
export function LedgerProvider({ ledger, children }: { ledger: LedgerRef; children: ReactNode }): ReactNode {
  return createElement(LedgerContext.Provider, { value: ledger }, children);
}
export function useLedger(): LedgerRef | null { return useContext(LedgerContext); }
